__turbopack_context__.v({
  "flex": "Heading-module__P2XDLW__flex",
  "heading-md": "Heading-module__P2XDLW__heading-md",
  "heading-sm": "Heading-module__P2XDLW__heading-sm",
  "heading-sm-decorated": "Heading-module__P2XDLW__heading-sm-decorated",
  "heading-xs": "Heading-module__P2XDLW__heading-xs",
  "heading-xs-decorated": "Heading-module__P2XDLW__heading-xs-decorated",
  "text-md-default": "Heading-module__P2XDLW__text-md-default",
  "text-md-important": "Heading-module__P2XDLW__text-md-important",
});
